import { SharedOauthApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useSharedOauthApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(() => new SharedOauthApi(configuration), [configuration]);
};
